import classNames from 'classnames';
import React from 'react';
import { useIntl } from 'react-intl';

import css from './PurchaseCompleteAlert.module.scss';

interface Props {
  labelType: string;
}

const PurchaseCompleteAlert = ({ labelType }: Props) => {
  const intl = useIntl();
  const classes = classNames(css.PurchaseCompleteAlert);

  return (
    <div className={classes}>
      <span className={css.PurchaseCompleteAlert__Title}>
        {intl.formatMessage({
          id: `purchases.purchaseCompleteAlert.title.${labelType}`,
        })}
      </span>
      <span className={css.PurchaseCompleteAlert__Text}>
        {intl.formatMessage({
          id: `purchases.purchaseCompleteAlert.message1.${labelType}`,
        })}
      </span>
      <span className={css.PurchaseCompleteAlert__Text}>
        {intl.formatMessage({
          id: `purchases.purchaseCompleteAlert.message2.${labelType}`,
        })}
      </span>
    </div>
  );
};

export default PurchaseCompleteAlert;
